import * as React from 'react';
export const daveSvg = React.forwardRef(function daveSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#3B853D',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.888 15.989a3.19 3.19 0 0 1-.89 2.278 3.044 3.044 0 0 1-2.212.948H4.957A.97.97 0 0 1 4 18.237v-4.39c0-.54.43-.978.957-.978h1.78c1.71 0 3.123 1.4 3.15 3.12Zm-1.865.054c0-.935-.56-1.693-1.652-1.693h-.507v3.385h.507c1.083 0 1.652-.759 1.652-1.692Zm7.941-.605v2.815a.957.957 0 0 1-.944.967h-.035a.927.927 0 0 1-.667-.284.968.968 0 0 1-.215-.34c-.268.262-.809.675-1.751.675-1.314 0-2.164-.82-2.164-2.09 0-1.061.844-1.829 2.15-1.955a4.714 4.714 0 0 1 1.703.166v-.074c0-1.125-1.299-.995-2.277-.765-1.138.27-1.48-1.223-.503-1.535a5.95 5.95 0 0 1 1.9-.29c.743 0 1.391.201 1.926.6.896.67.883 1.717.877 2.11Zm-1.927 1.131c-1.073-.32-1.953-.21-1.95.625.006.965 1.95.888 1.95-.445v-.18Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21.182 12.727c.7 0 1.163.742.872 1.392l-2.065 4.582a.959.959 0 0 1-.872.57.956.956 0 0 1-.872-.57L16.18 14.12c-.293-.65.171-1.392.872-1.392a.96.96 0 0 1 .901.649l1.164 3.294 1.162-3.294a.962.962 0 0 1 .903-.649Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M26.3 17.367a.747.747 0 0 1 .883-.01.786.786 0 0 1-.011 1.283c-.49.33-1.199.633-2.162.633-1.661 0-3.012-1.469-3.012-3.274s1.35-3.272 3.012-3.272c1.489 0 2.77 1.205 2.982 2.803l.006.065c.018.284-.08.553-.271.762-.193.206-.47.312-.75.312H23.89c.086.64.778 1.025 1.307 1.025.481 0 .786-.093 1.103-.327Zm-2.41-1.915h2.257c0-.255-.178-1.193-1.165-1.193-.58 0-1.093.561-1.093 1.193Z',
      fill: '#fff',
    }),
  );
});
daveSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var dave = {
  category: 'brand',
  colorable: false,
  name: 'dave',
  svg: daveSvg,
};
